import { navLinks } from "@/mocks/home";

const columns = [
  {
    title: "看进展",
    links: [
      { label: "实时进展时间线", href: "#progress" },
      { label: "焦点档案", href: "#follow" },
      { label: "近 24h 跟进速览", href: "#briefing" },
      { label: "追更提醒", href: "#briefing" },
    ],
  },
  {
    title: "追更标准",
    links: [
      { label: "我们的追更标准", href: "#method" },
      { label: "常见问题", href: "#faq" },
      { label: "最新进展说明", href: "#faq" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-200">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:py-14">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.4fr_0.6fr_0.7fr_1fr]">
          <div>
            <a href="#top" className="flex items-baseline gap-1">
              <span className="rounded bg-accent-500 px-1.5 py-0.5 text-sm font-black leading-none text-foreground-950">51</span>
              <span className="font-heading text-2xl font-black tracking-tight text-background-50">吃料</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-7 text-background-300">
              资讯聚合门户 · 持续更新实时跟进。热点有后续，51吃料替你把进展跟到底。
            </p>
            <div className="mt-5 flex items-center gap-2 text-xs text-background-400">
              <span className="flex items-center gap-1.5">
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400" />
                </span>
                实时跟进中
              </span>
            </div>
          </div>

          {columns.map((c) => (
            <div key={c.title}>
              <h4 className="text-sm font-bold text-background-50">{c.title}</h4>
              <ul className="mt-4 space-y-3">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="whitespace-nowrap text-[13px] text-background-300 transition-colors hover:text-accent-300">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="text-sm font-bold text-background-50">关于本站</h4>
            <p className="mt-4 text-xs leading-6 text-background-300">
              51吃料为资讯聚合与持续更新追踪平台，内容基于公开信息整理，旨在呈现多方后续发展，不构成对任何主体的定性判断。
            </p>
            <p className="mt-3 text-xs leading-6 text-background-400">
              部分线索正处于实时跟进中，可能存在信息滞后，欢迎通过站内反馈指正。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-primary-800/70 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-background-400">
            © 2026 51吃料 · 51吃料最新进展持续更新，后续发展跟踪报道进行中
          </p>
          <p className="flex items-center gap-4 text-xs text-background-400">
            {navLinks.slice(1, 4).map((n) => (
              <a key={n.href} href={n.href} className="whitespace-nowrap transition-colors hover:text-accent-300">{n.label}</a>
            ))}
          </p>
        </div>
      </div>
    </footer>
  );
}